import { render, staticRenderFns } from "./AddProfileCompetenciesDialog.vue?vue&type=template&id=ea775816&scoped=true"
import script from "./AddProfileCompetenciesDialog.vue?vue&type=script&lang=js"
export * from "./AddProfileCompetenciesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea775816",
  null
  
)

export default component.exports